/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { DotLoader, PulseLoader } from "react-spinners";

import { skaleMainBlue } from "config/UpduoColors";

interface LoadingDotsProps {
  color?: string;
  hideDots?: boolean;
  isAlternate?: boolean;
  size?: number;
}

export default function LoadingDots({
  color = skaleMainBlue,
  hideDots = false,
  isAlternate = false,
  size,
}: LoadingDotsProps) {
  if (isAlternate) {
    return (
      <DotLoader
        color={hideDots ? "transparent" : color}
        size={size ? size : 60}
        loading={true}
      />
    );
  }
  return (
    <PulseLoader
      color={hideDots ? "transparent" : color}
      size={size ? size : 15}
      loading={true}
    />
  );
}
